import formulaReducer from "./reducers";

export default formulaReducer;